import { BrandfolderHexColors } from '../enums/colors.js';

const defaultListboxDark = {
    backgroundColor: '#333',
    borderColor: 'transparent'
};
const defaultListboxLight = {
    backgroundColor: BrandfolderHexColors.White,
    borderColor: 'transparent'
};

export { defaultListboxDark, defaultListboxLight };
//# sourceMappingURL=listbox.js.map
